import Reveal from "./Reveal";
import CategoryCard from "./CategoryCard";

const CATEGORIES = [
  {
    name: "Bags & Luggage",
    skus: "120+ SKUs",
    desc: "Leather, vegan leather, and canvas bags — handbags, backpacks, travel luggage, and wallets. Custom branding and private label available.",
    image: "https://images.unsplash.com/photo-1584917865442-de89df76afd3?w=800&q=80",
  },
  {
    name: "Apparel",
    skus: "150+ SKUs",
    desc: "Men's, women's, and kids' clothing — casualwear, ethnic wear, activewear, and seasonal collections in cotton, denim, and blended fabrics.",
    image: "https://images.unsplash.com/photo-1558769132-cb1aea458c5e?w=800&q=80",
  },
  {
    name: "Footwear",
    skus: "100+ SKUs",
    desc: "Casual, formal, and athletic footwear including leather shoes, sneakers, sandals, and slippers across all size ranges.",
    image: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=800&q=80",
  },
  {
    name: "Watches",
    skus: "80+ SKUs",
    desc: "Analog and digital watches — fashion, sports, and smart-watch accessories from established Indian and partner manufacturers.",
    image: "https://images.unsplash.com/photo-1524592094714-0f0654e20314?w=800&q=80",
  },
  {
    name: "Jewellery & Accessories",
    skus: "90+ SKUs",
    desc: "Fashion jewellery, imitation jewellery, and accessories including necklaces, earrings, bangles, and belts.",
    image: "https://images.unsplash.com/photo-1611591437281-460bfbe1220a?w=800&q=80",
  },
  {
    name: "Food Items",
    skus: "60+ SKUs",
    desc: "Packaged foods, spices, snacks, and FMCG products meeting international food safety and labeling standards.",
    image: "https://images.unsplash.com/photo-1542838132-92c53300491e?w=800&q=80",
  },
];

export default function CategoriesGrid() {
  return (
    <section id="categories" className="section-shell !pt-0 !pb-12 md:!pb-14 bg-surface/40">
      <div className="section-inner">
        <div className="text-center max-w-2xl mx-auto mb-8 md:mb-10">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-primary tracking-tight">
            Explore Our Categories
          </h2>
          <div className="w-16 h-1 bg-accent mx-auto mt-5 rounded-full" />
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {CATEGORIES.map((cat, i) => (
            <Reveal key={cat.name} delay={i * 80}>
              <CategoryCard cat={cat} index={i} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
